<template>
  <div class="mid_scroll_content socialTrading">
    <loader v-show="pageLoader"></loader>
    <social-profile
      v-if="get_user.social_type == 1 && get_user.social_user == 3 && step == 1"
    />
    <section v-else class="cap_exhange_cur border-0 max-1440 pb-4">
      <div v-if="!user_type">
        <div class="mainTitle my-4">
          <h3 class="medium d-flex align-items-center">
            Start Crypto Social Trading Now!
            <img
              width="150"
              class="ml-3"
              src="../../../../static/website/images/powerd.png"
              alt="Powered"
              title="Powered by"
            />
          </h3>
          <p>How do you want to use Crypto Social Trading?</p>
        </div>
        <div class="SelectAnyType d-flex align-items-center pt-5">
          <a
            href="javascript:void(0)"
            class="card-body mr-4"
            @click="() => setType('LEADER')"
          >
            <img
              class="mb-3"
              src="../../../../static/website/images/tradeChart.svg"
              alt="tradeChart"
              title="As a Trader"
            />
            <h5 class="medium mb-3">As a Trader</h5>
            <p>
              Earn additional income while you trade. Attract investors to
              follow your strategies and you will get commissions!
            </p>
          </a>
          <a
            href="javascript:void(0)"
            class="card-body"
            @click="() => setType('FOLLOWER')"
          >
            <img
              class="mb-3"
              src="../../../../static/website/images/handpaid.svg"
              alt="tradeChart"
              title="As an Investor"
            />
            <h5 class="medium mb-3">As an Investor</h5>
            <p>
              Join the most transparent social trading network! Copy Top
              Performing Crypto Traders easily and reach your investment goals!
            </p>
          </a>
        </div>
        <div class="mt-5">
          <h3 class="mb-4">Start Crypto Social Trading Demo</h3>
          <div class="SelectAnyType d-flex align-items-center">
            <div class="fitVideo">
              <video width="400" height="240" controls class="mr-4">
                <source
                  src="../../../../static/website/video/capital-wallet-trader-registration.mp4"
                  type="video/mp4"
                />
                <!-- <source src="../../../../static/website/video/capital-wallet-trader-registration.ogv" type="video/ogg"> -->
              </video>
              <h6>Trader's Tutorial Video</h6>
            </div>
            <div class="sndVideo">
              <video width="400" height="240" controls>
                <source
                  src="../../../../static/website/video/investor-registrationcw.mp4"
                  type="video/mp4"
                />
                <!-- <source src="../../../../static/website/video/capital-wallet-trader-registration.ogv" type="video/ogg"> -->
              </video>
              <h6>Investor's Tutorial Video</h6>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="user_type == 'FOLLOWER'">
        <div class="row">
          <div class="col-12 col-md-12 my-4">
            <h3>Start Crypto Social Trading Now!</h3>
            <p>Here are the steps you need to follow</p>
          </div>
          <div class="col-12 col-md-3">
            <div class="stepTiline">
              <div
                class="card-body stepCount text-center"
                :class="step > 1 ? 'completed' : ''"
              >
                <span class="count">1</span>
                <p class="themecolor mb-0">Create A Social</p>
                <p class="themecolor mb-0">Trading Account</p>
              </div>
              <div
                class="card-body stepCount text-center"
                :class="{ completed: step > 4, current: step > 1 && step <= 4 }"
              >
                <span class="count">2</span>
                <p class="themecolor mb-0">Transfer Funds from Your</p>
                <p class="themecolor mb-0">Current Trading Account</p>
              </div>
              <div
                class="card-body stepCount text-center"
                :class="{ completed: step > 5, current: step > 4 }"
              >
                <span class="count">3</span>
                <p class="themecolor mb-0">Generate API & Secret Key to</p>
                <p class="themecolor mb-0 d-flex align-items-center">
                  link
                  <img
                    class="ml-2"
                    src="../../../../static/website/images/zuluLogo.svg"
                    alt="Zulu Logo"
                    title="Zulu Trade"
                  />
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-9">
            <!-- <div class="getStart mt-4 text-center" v-if="step == 1">
              <a
                href="javascript:void(0)"
                class="cap_btn lg min-250"
                @click="step = 2"
                >Get Started</a
              >
            </div> -->
            <div class="socialForm box-shadow max-700" v-if="step == 1">
              <h5 class="medium mb-4">Create A New Social Trading Account</h5>
              <div class="form-group my-5">
                <label class="mb-2 d-flex align-items-center"
                  >Name
                  <!-- Custom ToolTip -->
                  <div class="tooltip custom">
                    <feather size="16px" type="info"></feather>
                    <div class="tooltiptext">
                      <h6 class="medium mb-1">Name</h6>
                      <p>
                        Add a new name for your social trading account. This
                        account is different from your main account and will be
                        used for social trading purposes only.
                        <a href="javascript:void(0)">Learn More</a>
                      </p>
                    </div>
                  </div>
                </label>
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Social Trading"
                    v-model="label"
                  />
                  <p v-if="error" class="text-danger">
                    {{ error }}
                  </p>
                  <!-- <a href="javascript:void(0)" class="inputIcon"><feather size="16px" type="edit-2"></feather></a> -->
                </div>
              </div>
              <!-- <div class="form-group"><label class="mb-2">Account ID</label><div class="position-relative"><inputtype="text"class="form-control"placeholder="T518"name=""/></div></div>-->
              <div
                class="d-flex align-items-center justify-content-between mt-4"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium red"
                  @click="() => backStep()"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="cap_btn"
                  @click="() => confirmStep()"
                  >Next Step</a
                >
              </div>
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 2">
              <h5 class="medium mb-4">
                Transfer Funds From Manual Trading To Social Trading
              </h5>
              <!-- <p><strong class="themecolor">Manual Trading Account Balance:</strong>0.22079886 BTC</p>-->
              <div
                v-if="accountsWithMargin.length"
                class="selectedProgress custmSpace"
              >
                <div
                  v-for="wallet of accountsWithMargin"
                  :key="wallet.act_account_id"
                  class="repeatBlock d-flex align-items-center justify-content-between mb-3"
                >
                  <div class="d-flex align-items-center nameICon equal">
                    <span class="cpIcon mr-2"
                      ><img
                        :src="
                          '../../../../static/website/images/crypto_logos/' +
                          wallet.currency.toLowerCase() +
                          '.png'
                        "
                    /></span>
                    <p class="themecolor medium mb-0 cpNmae">
                      {{ wallet.currency }}
                    </p>
                  </div>
                  <div class="position-relative rangeSection">
                    <div
                      class="range-value addToolTip"
                      :style="`left:${leftValComputed[wallet.currency]};`"
                    >
                      <span class="d-flex align-items-center">
                        {{ data_value[wallet.currency] }}%
                        <div class="tooltip l-1 custom">
                          <feather size="16px" type="info"></feather>
                          <div class="tooltiptext">
                            <h6 class="medium mb-1">Amount Slider</h6>
                            <p>
                              Move the slider to add funds according to your
                              desired or proportion percentage from your
                              available balance
                            </p>
                          </div>
                        </div>
                      </span>
                    </div>
                    <input
                      class="progressbar"
                      type="range"
                      min="0"
                      max="100"
                      name="energy Level"
                      @change="(e) => setProgressBar(e.target.value, wallet)"
                      v-model="data_value[wallet.currency]"
                    />
                    <!-- <input class="progressbar" type="range" min="0" max="100" name="`energy Level" :v-model="test"/> -->
                  </div>
                  <div class="form-group indrive mb-0 position-relative">
                    <input
                      type="text"
                      class="form-control small"
                      placeholder=""
                      @change="(e) => setAmount(e.target.value, wallet)"
                      v-model="amount[wallet.currency]"
                    />
                    <div
                      class="maxVolume f-14 text-right position-absolute d-flex align-items-center"
                    >
                      <p class="mb-0 themecolor">
                        Max:{{
                          margin_list[wallet.act_account_id]
                            ? margin_list[wallet.act_account_id].freemargin
                            : 0
                        }}
                      </p>
                      <div class="tooltip right-0 custom">
                        <feather size="16px" type="info"></feather>
                        <div class="tooltiptext">
                          <h6 class="medium mb-1">Maximum Amount</h6>
                          <p>
                            This is the maximum amount of each asset you can
                            transfer to your social trading account
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="agreePage mt-5 mb-4">
                  <label class="customCheckbox"
                    >I agree that only these funds will be used for social
                    trading <input type="checkbox" v-model="agree" />
                    <span class="checkmark"></span>
                  </label>
                  <p v-if="error" class="text-danger">
                    {{ error }}
                  </p>
                </div>
              </div>
              <div class="d-flex justify-content-center py-3" v-else>
                <p>No account available for withdrawal</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-between border-top pt-4 w-100 mt-4"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium mr-3 red"
                  @click="() => backStep()"
                  >Cancel</a
                >
                <a
                  v-if="accountsWithMargin.length"
                  href="javascript:void(0)"
                  class="cap_btn"
                  @click="() => confirmStep()"
                  >Transfer Funds</a
                >
              </div>
              <!--               <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
 -->
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 3">
              <div class="successTransfer mb-4 text-center">
                <h5 class="semibold my-4">
                  Confirm your funds to be transferred to social trading account
                </h5>
              </div>
              <div
                class="selectedProgress d-flex flex-column align-items-center mt-5"
              >
                <div
                  class="middleColumn pb-4 border-bottom w-100 justify-content-between"
                >
                  <div
                    v-for="(value, key) in validAmounts"
                    class="repeatBlock d-flex align-items-center mb-3"
                  >
                    <div class="d-flex align-items-center nameICon equal">
                      <span class="cpIcon mr-2"
                        ><img
                          :src="
                            '../../../../static/website/images/crypto_logos/' +
                            key.toLowerCase() +
                            '.png'
                          "
                      /></span>
                      <p class="themecolor medium mb-0 cpNmae">{{ key }}</p>
                    </div>
                    <div class="progress bar">
                      <div
                        class="progress-bar themeBG"
                        role="progressbar"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%"
                      >
                        <span class="sr-only">30%</span>
                      </div>
                    </div>
                    <div
                      class="sameRight d-flex align-items-center justify-content-end"
                    >
                      <div class="volume equal">
                        <p class="mb-0">{{ value }}</p>
                      </div>
                      <div class="maxVolume equal">
                        <p class="mb-0">{{ key }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="authenticator w-100 grt lightgrayBG p-md-5 p-3 authenticator mt-5"
                >
                  <h4 class="border-bottom pb-3 mb-4">Validate OTP</h4>
                  <div class="form-group">
                    <div
                      class="mb-4 text-center d-inline-flex align-items-start"
                    >
                      <span
                        >Please enter the one time passcode shown in the
                        <strong>Authenticator</strong> app</span
                      >
                      <div class="tooltip right-0 custom">
                        <feather size="16px" type="info"></feather>
                        <div class="tooltiptext">
                          <h6 class="medium mb-1">Google Verification Code</h6>
                          <p>
                            Enter a short numeric code sent directly to you on
                            your google authenticator to verify your identity
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- <img src="../../../../static/website/images/authenticator.png" alt="authenticator" title="Google Authenticator"/> -->
                    <div class="text-left">
                      <!-- <label class="mb-2">Google Authentication Code</label> -->
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="******"
                          name=""
                          v-model="gauth"
                        />
                        <p v-if="error" class="text-danger">
                          {{ error }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="steps mt-4 text-center">
                <a
                  href="javascript:void(0)"
                  class="cap_btn min-250"
                  @click="() => confirmStep()"
                  >Confirm Transfer</a
                >
              </div>
              <!--               <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
 -->
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 4">
              <div class="successTransfer mb-4 text-center">
                <img
                  src="../../../../static/website/images/successRotate.svg"
                  alt="success"
                  title="Zulu Trade"
                />
                <h5 class="semibold mt-4">
                  Your funds transfer to social trading account was successful.
                </h5>
                <p>
                  You can now generate API and Secret keys to link your account
                  with Zulu Trade
                </p>
              </div>
              <div
                class="selectedProgress stepProgressbar d-flex flex-column align-items-center mt-5"
              >
                <div
                  class="middleColumn pb-4 border-bottom w-100 justify-content-between"
                >
                  <div
                    v-for="(value, key) in successWallets"
                    class="repeatBlock d-flex align-items-center mb-3"
                  >
                    <div class="d-flex align-items-center nameICon equal">
                      <span class="cpIcon mr-2"
                        ><img
                          :src="
                            '../../../../static/website/images/crypto_logos/' +
                            value.currency.toLowerCase() +
                            '.png'
                          "
                      /></span>
                      <p class="themecolor medium mb-0 cpNmae">
                        {{ value.currency }}
                      </p>
                    </div>
                    <div class="progress equal">
                      <div
                        class="progress-bar themeBG"
                        role="progressbar"
                        aria-valuenow="30"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 100%"
                      >
                        <span class="sr-only">30%</span>
                      </div>
                    </div>
                    <div class="volume equal">
                      <p class="mb-0">{{ value.amount }}</p>
                    </div>
                    <div class="maxVolume equal">
                      <p class="mb-0">{{ value.currency }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="steps mt-4 text-center">
                <a
                  href="javascript:void(0)"
                  class="cap_btn min-250"
                  @click="() => confirmStep()"
                  >Next</a
                >
              </div>
            </div>
            <div class="socialForm box-shadow max-500" v-if="step == 5">
              <h5 class="medium mb-4">Generate New API Key</h5>
              <div class="form-group">
                <label class="mb-2"
                  >API Key Label
                  <div class="tooltip custom">
                    <feather size="16px" type="info"></feather>
                    <div class="tooltiptext">
                      <h6 class="medium mb-1">API Key Label</h6>
                      <p>
                        Enter an API key name(for example, Social Trading) in
                        this field
                      </p>
                    </div>
                  </div>
                </label>
                <div class="position-relative greenBorder">
                  <input
                    type="text"
                    v-model="label"
                    class="form-control"
                    placeholder=""
                    name=""
                  />
                  <p v-if="nameError" class="text-danger">
                    {{ nameError }}
                  </p>
                  <!-- <a href="javascript:void(0)" class="inputIcon" ><feather size="16px" type="edit-2"></feather ></a> -->
                </div>
                <!-- <p class="reconted green f-12 d-flex align-items-center"> <feather type="check"></feather> Recommended </p>-->
              </div>
              <div class="authenticator">
                <img
                  src="../../../../static/website/images/authenticator.png"
                  alt="authenticator"
                  title="Google Authenticator"
                />
                <div class="form-group">
                  <label class="mb-2"
                    >Google Authentication Code
                    <div class="tooltip custom">
                      <feather size="16px" type="info"></feather>
                      <div class="tooltiptext">
                        <h6 class="medium mb-1">Google Verification Code</h6>
                        <p>
                          Enter a short numeric code sent directly to you on
                          your google authenticator to verify your identity
                        </p>
                      </div>
                    </div>
                  </label>
                  <div class="position-relative">
                    <input
                      v-model="gauth"
                      type="text"
                      class="form-control"
                      placeholder="******"
                      name=""
                    />
                    <p v-if="gauthError" class="text-danger">
                      {{ gauthError }}
                    </p>
                  </div>
                </div>
                <p>
                  <strong>Disclaimer:</strong> Only these keys are valid to link
                  Zulu Trade for social trading.
                </p>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mt-4"
              >
                <a
                  href="javascript:void(0)"
                  class="cancel-btn medium red"
                  @click="() => backStep()"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="cap_btn"
                  @click="() => confirmStep()"
                  >Create New Key</a
                >
              </div>
              <div v-if="error" class="mt-1 alert alert-danger">
                {{ error }}
              </div>
            </div>
            <div class="socialForm box-shadow max-900" v-if="step == 6">
              <div class="successTransfer mb-4 text-center">
                <feather type="check-circle"></feather>
                <h5 class="semibold mb-3">
                  Congratulations, API Key Created Successfully!
                </h5>
                <p>
                  Your social trading account is ready to be linked to Zulu
                  Trade Platform. Please copy your API and secret keys.
                </p>
              </div>
              <div class="apiName my-5 border-bottom pb-3">
                <h5 class="semibold">API Name</h5>
              </div>
              <div class="max-500 apiCopy">
                <div class="walletBlock position-relative mb-4">
                  <label class="mb-2"
                    >API Key
                    <div class="tooltip custom">
                      <feather size="16px" type="info"></feather>
                      <div class="tooltiptext">
                        <h6
                          class="medium semibold border-bottom pb-4 mb-4 mb-md-5"
                        >
                          API Key
                        </h6>
                        <p>
                          Copy your API key somewhere safe and paste it on
                          ZuluTrade platform to connect it with Capital Wallet
                          account
                        </p>
                      </div>
                    </div>
                  </label>
                  <div class="bg-white border position-relative copyCode">
                    <div class="copied" v-if="msgCopied">
                      <span>Copied</span>
                    </div>
                    <p class="mb-0">
                      {{
                        apiKeyResponse.length
                          ? apiKeyResponse[0].apiKey
                          : "********"
                      }}
                    </p>
                    <a
                      v-if="apiKeyResponse.length"
                      href="javascript:void(0)"
                      v-clipboard:copy="
                        apiKeyResponse.length
                          ? apiKeyResponse[0].apiKey
                          : '********'
                      "
                      v-clipboard:success="() => onCopy(false)"
                      class="copyBtn position-absolute"
                    >
                      <feather type="copy"></feather>
                    </a>
                  </div>
                </div>
                <div class="walletBlock position-relative mb-4">
                  <label class="mb-2"
                    >Secret Key
                    <div class="tooltip custom">
                      <feather size="16px" type="info"></feather>
                      <div class="tooltiptext">
                        <h6 class="medium mb-1">Secret Key</h6>
                        <p>
                          For security reasons, the API secret will never be
                          displayed again. Never share your API secret with
                          anyone and keep it somewhere safe
                        </p>
                      </div>
                    </div>
                  </label>
                  <div class="bg-white border position-relative copyCode">
                    <div class="copied" v-if="msgCopied1">
                      <span>Copied</span>
                    </div>
                    <p class="mb-0">
                      {{
                        apiKeyResponse.length
                          ? apiKeyResponse[0].clientSecretKey
                          : "********"
                      }}
                    </p>
                    <a
                      v-if="apiKeyResponse.length"
                      v-clipboard:copy="
                        apiKeyResponse.length
                          ? apiKeyResponse[0].clientSecretKey
                          : '********'
                      "
                      v-clipboard:success="() => onCopy(true)"
                      href="javascript:void(0)"
                      class="copyBtn position-absolute"
                    >
                      <feather type="copy"></feather>
                    </a>
                  </div>
                </div>
                <div>
                  <a
                    v-if="!apiKeyResponse.length"
                    href="javascript:void(0)"
                    class="cap_btn lg min-250"
                    @click="() => openModal('gauthModal')"
                    >View</a
                  >
                </div>
              </div>
              <div class="disclaimerAlert text-center mt-4">
                <p
                  class="d-inline-flex align-items-center justify-content-center mb-0"
                >
                  <feather class="mr-3" type="alert-triangle"></feather>
                  <strong class="mr-2">Disclaimer:</strong> Please save your
                  secret key before making any more actions.
                </p>
              </div>
              <div class="steps mt-5 text-center">
                <a
                  href="https://www.zulutrade.com/login"
                  target="_blank"
                  class="cap_btn min-250"
                  >Connect With Zulu Trade</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="socialForm box-shadow mt-4 max-500" v-if="step == 5">
          <h5 class="medium mb-4">Generate New API Key</h5>
          <div class="form-group">
            <label class="mb-2">API Key Label</label>
            <div class="position-relative greenBorder">
              <input
                type="text"
                v-model="label"
                class="form-control"
                placeholder=""
                name=""
              />
              <!-- <a href="javascript:void(0)" class="inputIcon" ><feather size="16px" type="edit-2"></feather ></a> -->
            </div>
            <!-- <p class="reconted green f-12 d-flex align-items-center"> <feather type="check"></feather> Recommended </p>-->
          </div>
          <div class="authenticator">
            <img
              src="../../../../static/website/images/authenticator.png"
              alt="authenticator"
              title="Google Authenticator"
            />
            <div class="form-group">
              <label class="mb-2">Google Authentication Code</label>
              <div class="position-relative">
                <input
                  v-model="gauth"
                  type="text"
                  class="form-control"
                  placeholder="******"
                  name=""
                />
              </div>
            </div>
            <p>
              <strong>Disclaimer:</strong> Only these keys are valid to link
              Zulu Trade for social trading.
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-4">
            <a
              href="javascript:void(0)"
              class="cancel-btn medium"
              @click="() => backStep()"
              >Cancel</a
            >
            <a
              href="javascript:void(0)"
              class="cap_btn"
              @click="() => confirmStep()"
              >Create New Key</a
            >
          </div>
          <div v-if="error" class="mt-1 alert alert-danger">{{ error }}</div>
        </div>
        <div class="socialForm box-shadow mt-4 max-900" v-if="step == 6">
          <div class="successTransfer mb-4 text-center">
            <feather type="check-circle"></feather>
            <h5 class="semibold mb-1">
              Congratulations, API Key Created Successfully!
            </h5>
            <p>
              Your social trading account is ready to be linked to Zulu Trade
              Platform. Please copy your API and secret keys.
            </p>
          </div>
          <div class="apiName mt-5"><h5 class="semibold">API Name</h5></div>
          <div class="max-500 apiCopy">
            <div class="walletBlock position-relative mb-4">
              <label class="mb-2">API Key</label>
              <div class="bg-white border position-relative copyCode">
                <div class="copied" v-if="msgCopied"><span>Copied</span></div>
                <p class="mb-0">
                  {{
                    apiKeyResponse.length
                      ? apiKeyResponse[0].apiKey
                      : "********"
                  }}
                </p>
                <a
                  v-if="apiKeyResponse.length"
                  href="javascript:void(0)"
                  v-clipboard:copy="
                    apiKeyResponse.length
                      ? apiKeyResponse[0].apiKey
                      : '********'
                  "
                  v-clipboard:success="() => onCopy(false)"
                  class="copyBtn position-absolute"
                >
                  <feather type="copy"></feather>
                </a>
              </div>
            </div>
            <div class="walletBlock position-relative mb-4">
              <label class="mb-2">Secret Key</label>
              <div class="bg-white border position-relative copyCode">
                <div class="copied" v-if="msgCopied1"><span>Copied</span></div>
                <p class="mb-0">
                  {{
                    apiKeyResponse.length
                      ? apiKeyResponse[0].clientSecretKey
                      : "********"
                  }}
                </p>
                <a
                  v-if="apiKeyResponse.length"
                  v-clipboard:copy="
                    apiKeyResponse.length
                      ? apiKeyResponse[0].clientSecretKey
                      : '********'
                  "
                  v-clipboard:success="() => onCopy(true)"
                  href="javascript:void(0)"
                  class="copyBtn position-absolute"
                >
                  <feather type="copy"></feather>
                </a>
              </div>
            </div>
            <div>
              <a
                v-if="!apiKeyResponse.length"
                href="javascript:void(0)"
                class="cap_btn lg min-250"
                @click="() => openModal('gauthModal')"
                >View</a
              >
            </div>
          </div>
          <div class="disclaimerAlert text-center mt-4">
            <p
              class="d-inline-flex align-items-center justify-content-center mb-0"
            >
              <feather class="mr-3" type="alert-triangle"></feather>
              <strong class="mr-2">Disclaimer:</strong> Please save your secret
              key before making any more actions.
            </p>
          </div>
          <div class="steps mt-5 text-center">
            <a
              href="https://www.zulutrade.com/login"
              target="_blank"
              class="cap_btn min-250"
              >Connect With Zulu Trade</a
            >
          </div>
        </div>
      </div>
    </section>
    <div
      class="modal fade"
      id="internalTransferErrorModal"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            @click="() => closeModal('internalTransferErrorModal')"
            type="button"
            class="close text-right pr-2"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center socialForm">
            <h5>Funds from following wallets could not be transferred</h5>
            <div class="middleColumn selectedProgress">
              <div
                v-for="(value, key) in errorWallets"
                class="repeatBlock d-flex align-items-center mb-3"
              >
                <div class="d-flex align-items-center nameICon equal">
                  <span class="cpIcon mr-2"
                    ><img
                      :src="
                        '../../../../static/website/images/crypto_logos/' +
                        value.currency.toLowerCase() +
                        '.png'
                      "
                  /></span>
                  <p class="themecolor medium mb-0 cpNmae">
                    {{ value.currency }}
                  </p>
                </div>
                <div class="progress equal">
                  <div
                    class="progress-bar secondaryBG"
                    role="progressbar"
                    aria-valuenow="30"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 100%"
                  >
                    <span class="sr-only">30%</span>
                  </div>
                </div>
                <div class="volume equal">
                  <p class="mb-0">{{ value.amount }}</p>
                </div>
                <div class="maxVolume equal">
                  <p class="mb-0">{{ value.currency }}</p>
                </div>
              </div>
            </div>
            <a
              @click="() => closeModal('internalTransferErrorModal')"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Ok</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="gauthModal"
      role="dialog"
      aria-labelledby="gauthModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            @click="() => closeModal('gauthModal')"
            type="button"
            class="close text-right pr-2"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center socialForm">
            <div class="authenticator">
              <!-- <img src="../../../../static/website/images/authenticator.png" alt="authenticator" title="Google Authenticator"/> -->
              <div class="form-group">
                <label class="mb-2">Google Authentication Code</label>
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="******"
                    name=""
                    v-model="gauth"
                  />
                </div>
              </div>
            </div>
            <a
              @click="() => getApiKeys()"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Get Keys</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tradingMixins from "@/plugins/trading";
import commonMixins from "@/plugins/commonAll";
import VueSlickCarousel from "vue-slick-carousel";
import SocialProfile from "./social_profile";

export default {
  name: "Portfolio",
  mixins: [tradingMixins, commonMixins],
  data() {
    return {
      filter: false,
      internalTransferResponse: {},
      pageLoader: false,
      msgCopied: false,
      msgCopied1: false,
      charTab: "date",
      user_type: null,
      margin_list: {},
      label: "",
      accountsList: [],
      apiKeyResponse: {},
      data_value: {},
      gauth: "",
      agree: false,
      amount: {},
      error: null,
      nameError: null,
      gauthError: null,
      // leftVal: {},
      step: 1,
      trans_id: null,
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold: 5,
      },
    };
  },
  created() {
    this.pageName("Social Trading");
    this._runTradingAccount({
      globalParams: {},
      localParams: { parameter: this },
    });
    if (this.get_user.social_user >= 1) {
      this._runTradingAccount({
        globalParams: {
          is_social: "1",
        },
        localParams: { parameter: this },
      });
    }
    this._runGetMarginInfo({
      globalParams: {},
      localParams: { parameter: this, page: "exchange" },
    });
    /**
     * social_type: 0-none, 1-follower, 2-leader
     * social_user(steps): 0-none, 1-account created, 2-internal transfer, 3-api
     */
    if (this.get_user.social_type > 0) {
      if (this.get_user.social_type == 1) {
        this.user_type = "FOLLOWER";
        if (this.get_user.social_user == 1) {
          this.step = 2;
        } else if (this.get_user.social_user == 2) {
          this.step = 5;
        } else if (this.get_user.social_user == 3) {
          this.step = 1;
        }
      } else {
        this.user_type = "LEADER";
        if (this.get_user.social_user == 3) {
          this.step = 6;
        } else {
          this.step = 5;
        }
      }
    }
  },
  watch: {
    get_user(value) {
      if (value.social_type > 0) {
        if (value.social_type == 1) {
          this.user_type = "FOLLOWER";
          if (value.social_user == 1) {
            this.step = 2;
          } else if (value.social_user == 2) {
            this.step = 5;
          } else if (value.social_user == 3) {
            this.step = 1;
          }
        } else {
          this.user_type = "LEADER";
          if (value.social_user == 3) {
            this.step = 6;
          } else {
            this.step = 5;
          }
        }
      }
    },
    step(value) {
      this.error = null;
      this.gauth = "";
      this.label = "";
    },
    tradingAccount(value) {
      this.accountsList = value;
    },
    margin_list(value) {
      if (Object.keys(value).length) {
        let counter = 0;
        for (let key in value) {
          if (counter == 0) {
            this.data_value[value[key].currency] = "20";
            this.amount[value[key].currency] = value[key].freemargin / 5;
          } else {
            this.data_value[value[key].currency] = "0";
            this.amount[value[key].currency] = 0;
          }
          counter++;
        }
      }
    },
    internalTransferResponse(value) {
      if (value.transfer && Object.keys(value.transfer).length) {
        for (let key in value.transfer) {
          if (value.transfer[key].error == 1) {
            this.openModal("internalTransferErrorModal");
            break;
            return;
          }
        }
      }
    },
  },
  computed: {
    accountsWithMargin() {
      let arr = [];
      if (this.tradingAccount.length) {
        for (let account of this.tradingAccount[0].subAccounts) {
          if (
            this.margin_list[account.act_account_id] &&
            this.margin_list[account.act_account_id].freemargin
          )
            arr.push(account);
        }
      }
      return arr;
    },
    leftValComputed() {
      let obj = {};
      for (let key in this.margin_list) {
        let newValue = this.data_value[this.margin_list[key].currency];
        let newPosition = 10 - newValue * 0.2;
        obj[
          this.margin_list[key].currency
        ] = `calc(${newValue}% + (${newPosition}px))`;
      }
      return obj;
    },
    validAmounts() {
      let obj = {};
      for (let key in this.amount) {
        if (this.amount[key] > 0) {
          obj[key] = this.amount[key];
        }
      }
      return obj;
    },
    errorWallets() {
      try {
        let obj = {};
        if (
          this.internalTransferResponse.transfer &&
          Object.keys(this.internalTransferResponse.transfer).length
        ) {
          for (let key in this.internalTransferResponse.transfer) {
            if (this.internalTransferResponse.transfer[key].error == 1) {
              obj[key] = this.internalTransferResponse.transfer[key];
            }
          }
        }
        return obj;
      } catch (error) {
        return {};
      }
    },
    successWallets() {
      try {
        let obj = {};
        if (
          this.internalTransferResponse.transfer &&
          Object.keys(this.internalTransferResponse.transfer).length
        ) {
          for (let key in this.internalTransferResponse.transfer) {
            if (this.internalTransferResponse.transfer[key].error == 0) {
              obj[key] = this.internalTransferResponse.transfer[key];
            }
          }
        }
        return obj;
      } catch (error) {
        return {};
      }
    },
  },
  components: { VueSlickCarousel, SocialProfile },
  methods: {
    onCopy(isClientSecret) {
      if (isClientSecret) {
        this.msgCopied1 = true;
        setTimeout(() => {
          this.msgCopied1 = false;
        }, 3000);
      } else {
        this.msgCopied = true;
        setTimeout(() => {
          this.msgCopied = false;
        }, 3000);
      }
    },
    setType(type) {
      if (type == "LEADER") {
        this.step = 5;
      }
      this.user_type = type;
    },
    openModal(id) {
      let modal = document.getElementById(id);
      modal.classList.add("show");
    },
    closeModal(id) {
      let modal = document.getElementById(id);
      modal.classList.remove("show");
    },
    backStep() {
      if (this.get_user.social_user == 1 && this.step > 2) {
        this.step--;
      } else {
        this.user_type = null;
      }
      if (this.get_user.social_user == 2 && this.step > 5) {
        this.step--;
      } else {
        this.user_type = null;
        this.step = 1;
      }
    },
    setProgressBar(val, wallet) {
      let newObj = { ...this.data_value, [wallet.currency]: val };
      this.data_value = Object.assign({}, newObj);
      let freemargin = this.margin_list[wallet.act_account_id].freemargin;
      let newAmount = {
        ...this.amount,
        [wallet.currency]: freemargin * (val / 100),
      };
      this.amount = Object.assign({}, newAmount);
    },
    setAmount(val, wallet) {
      let newObj = { ...this.amount, [wallet.currency]: val };
      this.amount = Object.assign({}, newObj);
      let freemargin = this.margin_list[wallet.act_account_id].freemargin;
      let newDataValue = {
        ...this.data_value,
        [wallet.currency]: ((val / freemargin) * 100).toFixed(2),
      };
      this.data_value = Object.assign({}, newDataValue);
    },
    confirmStep() {
      this.error = null;
      this.gauthError = null;
      this.nameError = null;
      if (this.step == 1) {
        if (this.label == "") this.error = "Please enter name";
        if (this.error) return;
        this.createAccount();
      } else if (this.step == 2) {
        if (!this.agree) this.error = "Please check above box to proceed";
        if (Object.keys(this.validAmounts).length == 0)
          this.error = "Add funds from atleast 1 wallet to transfer";
        if (this.error) return;
        this.step++;
      } else if (this.step == 3) {
        if (this.gauth == "") this.error = "Please enter G-auth code";
        if (Object.keys(this.validAmounts).length == 0)
          this.error = "Add funds from atleast 1 wallet to transfer";
        if (this.error) return;
        this.internalTransferVerify();
      } else if (this.step == 4) {
        this.step++;
      } else if (this.step == 5) {
        if (this.gauth == "") {
          this.gauthError = "Please enter G-auth code";
        }
        if (this.label == "") {
          this.nameError = "Please enter name";
        }
        if (this.gauthError || this.nameError) return;
        this.generateApiKey();
      }
    },
    createAccount() {
      let obj = {
        globalParams: {
          is_social: "1",
          label: this.label,
        },
        localParams: {
          parameter: this,
        },
      };
      this._runCreateAccount(obj);
    },
    internalTransferVerify() {
      let accountsObj = {};
      for (let key in this.margin_list) {
        if (this.validAmounts[this.margin_list[key].currency]) {
          accountsObj[key] = {
            id: key,
            currency: this.margin_list[key].currency,
            amount: this.validAmounts[this.margin_list[key].currency],
          };
        }
      }
      let obj = {
        globalParams: {
          account_id: this.accountsList[0].account_id,
          to_account_id: this.socialAccount[0].account_id,
          operation: "TRANSFER",
          otp: this.gauth,
          transfer: accountsObj,
        },
        localParams: {
          parameter: this,
        },
      };
      this._runInternalTransferVerify(obj);
    },
    generateApiKey() {
      let obj = {
        globalParams: {
          otp: this.gauth,
          label: this.label,
        },
        localParams: {
          parameter: this,
        },
      };
      this._runGenerateApiKey(obj);
    },
    getApiKeys() {
      let obj = {
        globalParams: {
          otp: this.gauth,
          type: "KEYS",
          key_type: this.user_type == "FOLLOWER" ? "1" : "2",
        },
        localParams: {
          parameter: this,
        },
      };
      this._runGetApiKey(obj);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/social-trading/social_trading.vue